import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/firestore'

firebase.initializeApp({
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_DOMAIN + '.firebaseapp.com',
  databaseURL: 'https://' + process.env.FIREBASE_DOMAIN + '.firebaseapp.com',
  projectId: process.env.FIREBASE_DOMAIN,
  storageBucket: 'gs://' + process.env.FIREBASE_DOMAIN + '.appspot.com/',
  messagingSenderId: process.env.FIREBASE_SENDER_ID
})

Vue.prototype.$firebase = firebase.firestore()
Vue.firebase = Vue.prototype.$firebase
